import React, { useEffect, useState } from "react";

export default function CookieConsent() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");

    if (!consent) {
      setShowPopup(true);
    } else if (consent === "accepted") {
      enableCookies();
    }
  }, []);

  const enableCookies = () => {
    console.log("Cookies Accepted");

    // Google Analytics Example
    // window.gtag && window.gtag('consent', 'update', {
    //   analytics_storage: 'granted',
    //   ad_storage: 'granted'
    // });

    // Future tracking scripts can be enabled here
  };

  const disableCookies = () => {
    console.log("Cookies Declined");

    // Google Analytics Example
    // window.gtag && window.gtag('consent', 'update', {
    //   analytics_storage: 'denied',
    //   ad_storage: 'denied'
    // });

    // Disable tracking scripts here
  };

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    enableCookies();
    setShowPopup(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookieConsent", "declined");
    disableCookies();
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="cookie-overlay">
  <div className="cookie-popup">
    <div className="cookie-content">
      <h3>Cookie Preferences</h3>
      <p>
        We use cookies to improve your experience, analyse website traffic
        and personalise content. You can accept all cookies or reject
        non-essential cookies.
      </p>
    </div>

    <div className="cookie-buttons">
      <button className="accept-btn" onClick={acceptCookies}>
        Accept All
      </button>

      <button className="decline-btn" onClick={declineCookies}>
        Reject All
      </button>
    </div>
  </div>
</div>
  );
}